import { Field, Formik } from 'formik'
import { useMemo } from 'react'

import { Flex, VStack } from '@chakra-ui/react'
import { useStore } from '@tanstack/react-store'
import { userCardStore } from 'shared/store/userCard'
import { Button, Heading, InputForm } from 'uikit'
import { Form, FormGrid } from 'uikit/layout'
import { formFields, formFieldsLabel } from './UserEditFormInternal.constants'
import { useUpdateUserInternal } from './services'

export const UserEditFormInternal = () => {
  const userCard = useStore(userCardStore)

  const { mutate: sendUserData, isLoading: userDataIsMutate } = useUpdateUserInternal()

  const handleForm = async (values) => {
    sendUserData({
      id: userCard.id,
      ...values,
    })
  }

  const initialValues = useMemo(
    () => ({
      accountNumber: userCard.accountNumber || undefined,
      contractNumber: userCard.contractNumber || undefined,
      clientId: userCard.clientId || undefined,
    }),
    [userCard]
  )

  const fieldsIsDisabled = userDataIsMutate

  return (
    <VStack alignItems="flex-start" maxW="1000px">
      <Formik initialValues={initialValues} enableReinitialize onSubmit={handleForm}>
        {(formProps) => {
          return (
            <Form
              w="100%"
              onSubmit={formProps.handleSubmit}
              footer={
                <Flex w="100%" justifyContent="flex-end">
                  <Button
                    type="submit"
                    colorPalette="orange"
                    loading={userDataIsMutate}
                    disabled={!formProps.isValid}
                  >
                    Обновить
                  </Button>
                </Flex>
              }
            >
              <Heading mb={4}>Документы</Heading>
              <FormGrid columns={2} alignItems="none">
                <Field
                  name={formFields.accountNumber}
                  label={formFieldsLabel[formFields.accountNumber]}
                  component={InputForm}
                  disabled={fieldsIsDisabled}
                />
                <Field
                  name={formFields.contractNumber}
                  label={formFieldsLabel[formFields.contractNumber]}
                  component={InputForm}
                  disabled={fieldsIsDisabled}
                />
                <Field
                  name={formFields.clientId}
                  label={formFieldsLabel[formFields.clientId]}
                  component={InputForm}
                  disabled={fieldsIsDisabled}
                />
              </FormGrid>
            </Form>
          )
        }}
      </Formik>
    </VStack>
  )
}
